// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface CourseId {
  id: string;
  internalId: string;
  isOnDemandCourse: boolean;
  isSpark: boolean;
}

export interface OnDemandSessionId {
  id: string;
}

export interface ItemDeadline {
  deadline: number;
}

export interface OnDemandModuleDeadline {
  deadline: number;
  moduleId: any;
}

export interface TimedItemLock {
  unlockTime?: number | null;
  relockTime?: number | null;
  timedItemLockCustomMessage?: string | null;
}

export interface ScheduleOverride {
  timedItemLocks: Record<string, TimedItemLock>;
}

export interface DegreeSession {
  degreeId: string;
}

export interface ModelsessionTypeMetadataDegreeSession {
  typeName: 'DegreeSession';
  definition: DegreeSession;
}

export interface CredentialTrackSession {
  degreeId: string;
}

export interface ModelsessionTypeMetadataCredentialTrackSession {
  typeName: 'CredentialTrackSession';
  definition: CredentialTrackSession;
}

export type ModelsessionTypeMetadata =
  ModelsessionTypeMetadataDegreeSession | ModelsessionTypeMetadataCredentialTrackSession;

export type ModelsessionTypeMetadataTypeName = 'DegreeSession' | 'CredentialTrackSession';

export interface OnDemandSessionsV1 {
  id: string;
  courseId: CourseId;
  discussionSessionId?: OnDemandSessionId | null;
  endedAt: any;
  enrollmentEndedAt: number;
  flexibleScheduleAllowed: boolean;
  isCredentialTrackSession: boolean;
  isDegreeSession: boolean;
  isNonTyped: boolean;
  isPreview: boolean;
  isPrivate: boolean;
  isPublicNonTyped: boolean;
  itemDeadlines?: Record<string, ItemDeadline> | null;
  moduleDeadlines: Array<OnDemandModuleDeadline>;
  scheduleOverride?: ScheduleOverride | null;
  sessionTypeMetadata?: ModelsessionTypeMetadata | null;
  startedAt: number;
  versionedBranchId?: string | null;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface OnDemandSessionsV1Connection {
  elements: Array<OnDemandSessionsV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface OnDemandSessionsV1AllByCourseQuery {
  OnDemandSessionsV1: {
    allByCourse: OnDemandSessionsV1Connection | null;
  } | null;
}

export interface OnDemandSessionsV1AllByCourseQueryVariables {
  courseId: string;
  includes?: string | null;
}

export interface OnDemandSessionsV1ByCourseQuery {
  OnDemandSessionsV1: {
    byCourse: OnDemandSessionsV1Connection | null;
  } | null;
}

export interface OnDemandSessionsV1ByCourseQueryVariables {
  courseId: string;
  includes?: string | null;
}

export interface OnDemandSessionsV1CurrentOpenByCourseQuery {
  OnDemandSessionsV1: {
    currentOpenByCourse: OnDemandSessionsV1Connection | null;
  } | null;
}

export interface OnDemandSessionsV1CurrentOpenByCourseQueryVariables {
  courseId: string;
  includes?: string | null;
}

export interface OnDemandSessionsV1DeleteQuery {
  OnDemandSessionsV1: {
    delete: OnDemandSessionsV1Connection | null;
  } | null;
}

export interface OnDemandSessionsV1DeleteQueryVariables {
  id: string;
  includes?: string | null;
}

export interface OnDemandSessionsV1GetQuery {
  OnDemandSessionsV1: {
    get: OnDemandSessionsV1Connection | null;
  } | null;
}

export interface OnDemandSessionsV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface OnDemandSessionsV1GetAllQuery {
  OnDemandSessionsV1: {
    getAll: OnDemandSessionsV1Connection | null;
  } | null;
}

export interface OnDemandSessionsV1GetAllQueryVariables {
  includes?: string | null;
}

export interface OnDemandSessionsV1MultiGetQuery {
  OnDemandSessionsV1: {
    multiGet: OnDemandSessionsV1Connection | null;
  } | null;
}

export interface OnDemandSessionsV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

export interface OnDemandSessionsV1NextEnrollableSessionsByUserAndCourseQuery {
  OnDemandSessionsV1: {
    nextEnrollableSessionsByUserAndCourse: OnDemandSessionsV1Connection | null;
  } | null;
}

export interface OnDemandSessionsV1NextEnrollableSessionsByUserAndCourseQueryVariables {
  userId: string;
  courseId: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface OnDemandSessionsV1ClearSessionMembershipsMutation {
  OnDemandSessionsV1: {
    clearSessionMemberships: OnDemandSessionsV1Connection | null;
  } | null;
}

export interface OnDemandSessionsV1ClearSessionMembershipsMutationVariables {
  id: string;
  includes?: string | null;
}

export interface OnDemandSessionsV1CreateMutation {
  OnDemandSessionsV1: {
    create: OnDemandSessionsV1Connection | null;
  } | null;
}

export interface OnDemandSessionsV1CreateMutationVariables {
  includes?: string | null;
}

export interface OnDemandSessionsV1HardDeleteMutation {
  OnDemandSessionsV1: {
    hardDelete: OnDemandSessionsV1Connection | null;
  } | null;
}

export interface OnDemandSessionsV1HardDeleteMutationVariables {
  id: string;
  includes?: string | null;
}

export interface OnDemandSessionsV1OverrideItemAvailabilityAndDeadlineMutation {
  OnDemandSessionsV1: {
    overrideItemAvailabilityAndDeadline: OnDemandSessionsV1Connection | null;
  } | null;
}

export interface OnDemandSessionsV1OverrideItemAvailabilityAndDeadlineMutationVariables {
  id: string;
  includes?: string | null;
}

export interface OnDemandSessionsV1UpdateMutation {
  OnDemandSessionsV1: {
    update: OnDemandSessionsV1Connection | null;
  } | null;
}

export interface OnDemandSessionsV1UpdateMutationVariables {
  id: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
      ? PartialConstruction<T[TKey]>
      : T[TKey];
};

export class OnDemandSessionsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'onDemandSessions.v1' as const;

  declare id: string;

  declare courseId: CourseId;

  declare discussionSessionId?: OnDemandSessionId | null;

  declare endedAt: any;

  declare enrollmentEndedAt: number;

  declare flexibleScheduleAllowed: boolean;

  declare isCredentialTrackSession: boolean;

  declare isDegreeSession: boolean;

  declare isNonTyped: boolean;

  declare isPreview: boolean;

  declare isPrivate: boolean;

  declare isPublicNonTyped: boolean;

  declare itemDeadlines?: Record<string, ItemDeadline> | null;

  declare moduleDeadlines: Array<OnDemandModuleDeadline>;

  declare scheduleOverride?: ScheduleOverride | null;

  declare sessionTypeMetadata?: ModelsessionTypeMetadata | null;

  declare startedAt: number;

  declare versionedBranchId?: string | null;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<OnDemandSessionsV1>) {
    super(params);
  }
}
